import React from 'react';
import { styled } from '@mui/material';
import { AgGridReact } from 'ag-grid-react';
import AgContainer from 'routes/BudgetModule/components/BudgetProposal/Resource/ExpenseIncome/components/AgContainer';
import TooltipCellRenderer from 'routes/BudgetModule/components/BudgetOverview/BudgetSynthesisAndRatios/BudgetBalance/TooltipCellRenderer';
import { TRACKABLE_EVENTS, trackEventBudget } from 'helpers/trackerHelpers';
import { Project } from 'routes/BudgetModule/shared/useGetProjects';
import { getProjectsColDefinitions } from '../helpers/colDefinitions';
import ActionsCellRenderer from './ActionsCellRenderer';

type Props = {
    projects: Project[];
};

const StyAgContainer = styled(AgContainer, { name: 'StyAgContainer' })(
    ({ theme }) => ({
        border: '0.5px solid lightgray',
        height: 'auto',
        width: 'auto',
        flex: 1,
        '.ag-header-cell': {
            padding: '0 !important',
            textAlign: 'center',
            borderRight: '1px solid lightgray',
        },
        '.ag-header-cell-label': {
            justifyContent: 'center',
        },
        '.ag-header-cell-text': {
            textTransform: 'unset !important',
            color: `${theme.palette.primary.main} !important`,
        },
    }),
);

const ProjectsGrid: React.FC<Props> = ({ projects }) => {
    const onSortChanged = (): void => {
        trackEventBudget(TRACKABLE_EVENTS.budget.settings.projects.sort);
    };

    const columns = getProjectsColDefinitions(projects);
    return (
        <StyAgContainer className="ag-theme-material">
            <AgGridReact
                rowHeight={40}
                headerHeight={50}
                rowData={projects}
                columnDefs={columns}
                onSortChanged={onSortChanged}
                components={{
                    tooltipCellRenderer: TooltipCellRenderer,
                    actionsCellRenderer: ActionsCellRenderer,
                }}
                defaultColDef={{
                    flex: 1,
                    sortable: true,
                    resizable: false,
                    menuTabs: [],
                    suppressNavigable: true,
                }}
                columnMenu="legacy"
            />
        </StyAgContainer>
    );
};

export default ProjectsGrid;
